import React from 'react';

import PhoneVerificationForm from 'components/PhoneVerificationForm';
import { BorrowerType } from 'enums/BorrowerType';

const BorrowerPhoneVerification = () => {
  return <PhoneVerificationForm borrowerType={BorrowerType.CoBorrower} />;
};

export default BorrowerPhoneVerification;
